<div
  class=" text-black py-2 px-4 flex flex-wrap items-center justify-between w-10/12 mx-auto">
  <div class="flex items-center gap-3">
    <img alt="" class="h-10" src="../../../../assets/images/emblem.png">
    <span class="text-xl cursor-pointer font-bold  text-primary ">e-Maboresho
    </span>
  </div>

  <div class="flex gap-2 items-center justify-between grow md:grow-0">

    <button [matMenuTriggerFor]="menuLang"
            mat-raised-button
            class="px-3  gap-1 !bg-gray-100  border flex justify-center !shadow-sm !rounded-full items-center  cursor-pointer">
      <span class="px-1"> {{ 'Language' |concat|translate }}</span>
      <mat-icon>translate</mat-icon>
    </button>

    <mat-menu #menuLang="matMenu">
      <mat-list>
        <mat-list-item (click)="changeLanguage('sw')" class="border-b hover:bg-gray-50 !cursor-pointer">
          <span>Kiswahili</span>
        </mat-list-item>
        <mat-list-item (click)="changeLanguage('en')" class="hover:bg-gray-50 !cursor-pointer">
          <span>English</span>
        </mat-list-item>
      </mat-list>
    </mat-menu>

    <!--    <label class="switch">-->
    <!--      <span *ngIf="!isLightMode" class="sun"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g-->
    <!--        fill="#C99900"><circle r="5" cy="12" cx="12"></circle><path-->
    <!--        d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"></path></g></svg></span>-->
    <!--      <span *ngIf="isLightMode" class="moon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path-->
    <!--        d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"></path></svg></span>-->
    <!--      <input type="checkbox" [(ngModel)]="isLightMode" (ngModelChange)="toggleTheme()" class="input">-->
    <!--      <span class="slider"></span>-->
    <!--    </label>-->
    <button [routerLink]="['','login']"
            class="!bg-gradient-to-tr from-primary to-accent dark:!bg-gray-700 !text-white !shadow-sm !rounded-full"
            mat-raised-button>
      <mat-icon>power_settings_new</mat-icon>
      Login
    </button>
  </div>
</div>
